// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import { ConstructFragmentOverride, GetCopyFromJson } from '~/contentstack';
import LinkButton from '../components/LinkButton';
import SvgImage from '../components/images/SvgImage';

export const query = graphql`
	fragment PageHeroWhiteBoxFragment on Ozk_page_heroCover_content {
		white_box {
			image_as_heading {
				alt_text
				image {
					...AssetFragment
				}
				mobile_image {
					...AssetFragment
				}
			}
			heading_jrte {
				json
			}
			copy_jrte {
				json
			}
			bottom_button {
				button_text
				button_link
				open_in_new_tab
				button_style
				button_features
			}
		}
	}
`;

/**
 * @typedef PageHeroWhiteBoxOptions
 * @property {string} uid // Fake value, not used.
 * @property {import('../components/LinkButton').ButtonOption} [bottom_button]
 * @property {import('../CSTypes').CSJRTE} [copy_jrte]
 * @property {import('../CSTypes').CSJRTE} [heading_jrte]
 * @property {import('../CSTypes').ImageAsHeadingOptions[]} [image_as_heading]
 *
 * @typedef PageHeroWhiteBoxProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<PageHeroWhiteBoxOptions>} options
 */
/** @type {import('~/types/React').ReactFC<PageHeroWhiteBoxProps>} */
const PageHeroWhiteBox = ({ options }) => {
	if (!options) {
		return null;
	}

	const imageAsHeading = options.image_as_heading?.[0];
	const hasButton = Array.isArray(options.bottom_button) ? !!options.bottom_button?.[0] : !!options.bottom_button;
	const pFrag = ConstructFragmentOverride('p');

	return (
		<div className="page-hero-white-box">
			<div className="white-box-content">
				{/* Add heading, use image if provided. */}
				{!!imageAsHeading?.image ? (
					<SvgImage
						options={{
							alt_text: imageAsHeading.alt_text,
							svg: imageAsHeading.image,
							mobileSvg: imageAsHeading.mobile_image,
						}}
						{...imageAsHeading.image.$?.url}
					/>
				) : !!options.heading_jrte ? (
					<h1 className="heading" {...options.heading_jrte?.$?.uid}>
						{GetCopyFromJson(options.heading_jrte, pFrag)}
					</h1>
				) : null}

				{/* Add Copy - jrte > basic */}
				{!!options.copy_jrte && <p {...options.copy_jrte?.$?.uid}>{GetCopyFromJson(options.copy_jrte, pFrag)}</p>}

				{/* Add button */}
				{hasButton && (
					<div>
						<LinkButton options={options.bottom_button} className="white-box-button" />
					</div>
				)}
			</div>
		</div>
	);
};

export default PageHeroWhiteBox;
